// import axios from '@axios'

// const baseUrl = '/api/v2'

const state = {
  openId: null,
  activeId: null,
  openIds: new Set([]),
}

const mutations = {
  setOpenId(state, id) {
    state.openId = id
  },
  setActiveId(state, id) {
    state.activeId = id
  },
  setOpenIds(state, id) {
    state.openIds = id
  },
}

const getters = {
  openIds: state => state.openIds,
  activeId: state => state.activeId,
}
export default {
  state,
  mutations,
  getters
  // actions
}
